import * as React from "react";

import {
    MapFinderConfiguration,
    MapFinderMapConfiguration,
} from "../../../config/map-viewer-configuration";
import {
    Button,
    Card,
    Image,
    Item,
    Icon as SemanticIcon,
    Input,
    Modal,
    Popup as SemanticPopup,
    Tab,
    TabPane
} from "semantic-ui-react";
import {Icon} from "../icon/icon";
import {Link} from "react-router-dom";

import "./map-finder.scss";
import {observer} from "mobx-react";
import keyboardKey from "keyboard-key";
import {SyntheticEvent} from "react";
import {FormatUtils} from "../../../utils/format-utils";
import {autorun} from "mobx";
import {IAppStore, withStore} from "../../stores/abstract-app-store";

export interface MapFinderProps {
    small?: boolean;
    store?: IAppStore; // this is injected by withStore
}

@observer
class MapFinderBase extends React.Component<MapFinderProps, any> {
    activeCard: React.RefObject<any> | null = null;
    searchFieldRef: React.RefObject<any> | null = null;
    autorunDisposers: any[] = [];
    constructor(props: MapFinderProps) {
        super(props);
        this.state = {
            activeIndex: 0,
            activeIndexBack: 0,
            searchTabIndex: -1,
            searchIsLoading: false,
            searchResults: [],
            searchResultIndex: 0,
            searchValue: ""
        };
        this.setOpen = this.setOpen.bind(this);
        this.addPane = this.addPane.bind(this);
        this.clearSearchInputField = this.clearSearchInputField.bind(this);
        this.handleSearchChange = this.handleSearchChange.bind(this);
        this.handleSearchKeyDown = this.handleSearchKeyDown.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
        this.searchFieldRef = React.createRef();
    }
    componentDidMount(): void {
        const {store} = this.props;
        this.autorunDisposers.push(autorun(() => {
            if(store?.MapFinderStore.visible) {
                // Quick and Dirty: Timeout da Suchfeld nicht sofort vorhanden ist.
                setTimeout(() => this.searchFieldRef?.current?.focus(), 100);
            }
        }));
    }
    componentWillUnmount(): void {
        this.autorunDisposers.forEach((disposer: any) => {
            disposer();
        });
        this.autorunDisposers.length = 0;
    }
    setOpen(openFlag: boolean): void {
        const {store} = this.props;
        store?.MapFinderStore.setVisible(openFlag);
    }
    genSmall(addParam: string): JSX.Element | undefined {
        const {store} = this.props;
        const groups: JSX.Element[] = [];
        store?.mapViewerConfig.meta.mapFinder?.forEach((maps) => {
            const mapList = maps.maps.map((map) => {
                if (map.id !== store?.appStore.topic?.id) {
                    let localFlag = true;
                    if (map.url.indexOf("http")===0) {
                        localFlag = false;
                    }
                    if (localFlag) {
                        return (<li key={map.id}>
                            <Link to={map.url} onClick={()=>this.setOpen(false)}>
                                {map.title}
                            </Link>
                        </li>);
                    } else {
                        return (<li key={map.id}>
                            <a href={map.url + addParam} target={"_blank"} rel={"noreferrer"}>
                                {map.title}
                            </a>
                        </li>);
                    }
                }else{
                    return;
                }
            });
            const appList = maps.apps?.map((map) => <li key={map.id}>
                <a href={map.url + addParam} target={"_blank"} rel={"noreferrer"}>
                    {map.title}{(map.login)? <Icon name={"lock"}/>: null}
                </a>
            </li>);
            groups.push(<div key={groups.length}><h4>{maps.id}</h4><ul>{mapList}{appList}</ul></div>);
        });
        return (<div className={"geo-map-finder"}>{groups}</div>);
    }
    handleSearchChange(e: SyntheticEvent, { value }: {value: string}): void {
        if (value.length < 1) {
            this.setState((state: any) => (
                {
                    activeIndex: state.activeIndexBack,
                    searchResults: [],
                    searchResultIndex: 0,
                    searchValue: ""
                })
            );
            return;
        }
        const { store } = this.props;
        const newState = {
            activeIndex: store?.mapViewerConfig.meta.mapFinder?.length,
            searchValue: value,
            searchTabIndex: store?.mapViewerConfig.meta.mapFinder?.length
        };
        this.setState(newState);
        const re = new RegExp(FormatUtils.escapeRegExp(value), "i");
        const isMatch = (result: MapFinderMapConfiguration) => re.test(result.title) || re.test(result.titleFull)
            || (result.keywords && result.keywords.some((keyword)=>re.test(keyword)));

        const filteredResults: MapFinderConfiguration = {
            id: "Suchresultate",
            maps: [],
            apps: []
        };
        const ids: string[] = [];
        store?.mapViewerConfig.meta.mapFinder?.forEach((data) => {
            let results: MapFinderMapConfiguration[] | undefined = data.maps.filter((map) => {
                if (isMatch(map)) {
                    if (!ids.includes(map.id)) {
                        ids.push(map.id);
                        return true;
                    }
                }
                return false;
            });
            if (results.length) {
                filteredResults.maps =
                    filteredResults.maps.concat(results);
            }
            results = data.apps?.filter((map) => {
                if (isMatch(map)) {
                    if (!ids.includes(map.id)) {
                        ids.push(map.id);
                        return true;
                    }
                }
                return false;
            });
            if (results?.length && filteredResults.apps) {
                filteredResults.apps =
                    filteredResults.apps.concat(results);
            }
        });
        this.setState({
            searchIsLoading: false,
            searchResults: filteredResults,
            searchResultIndex: 0
        });
    }
    handleSearchKeyDown(e: KeyboardEvent) {
        const { searchResults, searchResultIndex } = this.state;
        const code = keyboardKey.getCode(e);

        if (code === keyboardKey.Enter) {
            e.preventDefault();
            this.activeCard?.current.handleClick();
        }

        if (code === keyboardKey.ArrowDown) {
            e.preventDefault();
            const next = Math.min(searchResultIndex + 1, searchResults.maps.length + searchResults.apps.length - 1);
            this.setState({ searchResultIndex: next });
        }

        if (code === keyboardKey.ArrowUp) {
            e.preventDefault();
            const next = Math.max(searchResultIndex - 1, 0);
            this.setState({ searchResultIndex: next });
        }
    }
    handleTabChange(e: SyntheticEvent, { activeIndex }: { activeIndex: number }): void {
        this.setState({ activeIndex, activeIndexBack: activeIndex });
    }
    handleCardClick(link?: string, e?: SyntheticEvent): void {
        if(e){
            e.preventDefault();
        }
        if (link) {
            window.open(link);
        }
    }
    clearSearchInputField(): void {
        this.setState((state: any) => (
            {
                activeIndex: state.activeIndexBack,
                searchResults: [],
                searchResultIndex: 0,
                searchValue: ""
            }
        ));
    }
    addPane(maps: MapFinderConfiguration,
            panes: Array<{ menuItem: string; render: () => JSX.Element }>,
            addParam: string, activeItem = -9) {
        const {store} = this.props;
        let currentIndex = -1;
        const mapCards = maps.maps.map((map) => {
            if (map.id !== store?.appStore.topic?.id) {
                currentIndex++;
                let localFlag = true;
                if (map.url.indexOf("http")===0) {
                    localFlag = false;
                }
                let card: JSX.Element;
                if (currentIndex === activeItem) {
                    this.activeCard = React.createRef();
                }
                if (localFlag) {
                    card = (<Card
                        className={(currentIndex === activeItem)? "focus": undefined}
                        key={map.id}
                        as={Link}
                        ref={(currentIndex === activeItem)? this.activeCard: undefined}
                        to={map.url}
                        onClick={()=>this.setOpen(false)}>
                        <Image
                            src={store?.appConfig.appBasename + "images/mapFinder/finder_" + map.id + ".png"}
                            wrapped ui={false}/>
                        <Card.Content>
                            {map.title}
                        </Card.Content>
                    </Card>);
                } else {
                    card = (<Card
                        className={(currentIndex === activeItem)? "focus": undefined}
                        key={map.id}
                        href={map.url + addParam}
                        onClick={(e, data)=>this.handleCardClick(data.href, e)}
                        ref={(currentIndex === activeItem)? this.activeCard: undefined}
                        target={"_blank"}>
                        <Image
                            src={store?.appConfig.appBasename + "images/mapFinder/finder_" + map.id + ".png"}
                            wrapped ui={false}/>
                        <Card.Content>
                            {map.title}
                        </Card.Content>
                    </Card>);
                }
                return card;
            }else{
                return;
            }
        });
        const appCards = maps.apps?.map((map) => {
            currentIndex++;
            return <Card
                className={(currentIndex === activeItem)? "focus": undefined}
                key={map.id}
                href={map.url + addParam}
                onClick={(e, data)=>this.handleCardClick(data.href, e)}
                ref={(currentIndex === activeItem)? this.activeCard: undefined}
                target={"_blank"}>
                <Image
                    src={store?.appConfig.appBasename + "images/mapFinder/finder_" + map.id + ".png"}
                    wrapped ui={false}/>
                <Card.Content>
                    {map.title}{(map.login) ? <Icon name={"lock"}/> : null}
                </Card.Content>
            </Card>;
        });
        const render = () => (<TabPane><Item.Group>
            {(mapCards && mapCards.length > 0)? (
                <Item>
                    <Item.Content>
                        <Item.Header>Karten</Item.Header>
                        <Item.Description>
                            <Card.Group itemsPerRow={4}>{mapCards}</Card.Group>
                        </Item.Description>
                    </Item.Content>
                </Item>): null}
            {(appCards && appCards?.length > 0)? (<Item><Item.Content>
                <Item.Header>Anwendungen</Item.Header>
                <Item.Description>
                    <Card.Group itemsPerRow={4}>{appCards}</Card.Group>
                </Item.Description>
                <Item.Meta><Icon name={"lock"}/> Zugriff geschützt - Login benötigt</Item.Meta>
            </Item.Content></Item>): null}
            {(mapCards.length === 0 && (!appCards || appCards.length === 0))? (
                <Item>
                    <Item.Content>
                        <Item.Header>Karten</Item.Header>
                        <Item.Description>
                            Keine Karte gefunden.
                        </Item.Description>
                    </Item.Content>
                </Item>): null}
        </Item.Group></TabPane>);
        panes.push({ menuItem: maps.id, render });
        return panes;
    }
    render(): JSX.Element | null {
        const { small, store } = this.props;
        const { activeIndex, searchResults, searchResultIndex, searchValue } = this.state;
        const open = store?.MapFinderStore.visible;
        let mapFinder: JSX.Element | undefined;
        if (store?.mapViewerConfig.meta.mapFinder) {
            const panes: Array<{ menuItem: string; render: () => JSX.Element }> = [];
            const addParam = new URLSearchParams();
            if (store?.mapStore.view?.center) {
                addParam.set("FOCUS", Math.round(store?.mapStore.view.center.x)
                    + ":" + Math.round(store?.mapStore.view.center.y)
                    // für Esri / Google / Bing tiling Schema Runden
                    + ":" + (Math.round(store?.mapStore.view.scale / 35) * 35));
            }
            if(store?.mapStore.basemap){
                const tag = store?.mapStore.basemap.tags?.find((t) => t.toLowerCase().indexOf("mv6:")===0);
                if(tag){
                    addParam.set("BASEMAP", tag.substring(4).toUpperCase());
                }
            }
            let addParamString = addParam.toString();
            if (addParamString !== "") {
                addParamString = "?" + addParamString;
            }
            if (small) {
                mapFinder = this.genSmall(addParamString);
            } else {
                store?.mapViewerConfig.meta.mapFinder.forEach((maps) => {
                    this.addPane(maps, panes, addParamString);
                });
                if (searchValue) {
                    this.addPane(searchResults, panes, addParamString, searchResultIndex);
                }
                mapFinder = (<Modal
                    className={"geo-map-finder"}
                    centered={false}
                    dimmer={"blurring"}
                    open={open}
                    onClose={() => this.setOpen(false)}
                    onOpen={() => this.setOpen(true)}
                    trigger={
                        <div><SemanticPopup
                            content={"Weitere Karten"}
                            trigger={<Button><SemanticIcon name={"th"} /></Button>}
                            on={"hover"}/></div>
                    }
                >
                    <Modal.Header>Weitere Karten<div
                        className={"geo-filter "
                            + ((searchValue!=="")? "geo-input-has-value": "geo-input-has-no-value")}>
                        <Input
                            className={"search"}
                            placeholder="Kartensuche"
                            value={searchValue}
                            onChange={this.handleSearchChange}
                            onKeyDown={this.handleSearchKeyDown}
                            ref={this.searchFieldRef}
                        />
                        <Icon name={"magnifying_glass"}/>
                        <Icon
                            className={"geo-clear-field"}
                            name={"navigate_cross"}
                            onClick={this.clearSearchInputField}
                            title={"Text löschen"} />
                    </div></Modal.Header>
                    <Modal.Content scrolling>
                        <Modal.Description>
                            <Tab
                                activeIndex={activeIndex}
                                panes={panes}
                                menu={{ fluid: true, vertical: true, tabular: true }}
                                onTabChange={this.handleTabChange}/>
                        </Modal.Description>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button onClick={() => this.setOpen(false)} primary>
                            Schliessen
                        </Button>
                    </Modal.Actions>
                </Modal>);
            }
        }
        return <>{mapFinder}</>;
    }
}

export const MapFinder = withStore(MapFinderBase);
